var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50033 10L5.83366 10L5.83366 11.3333L4.50033 11.3333M4.50033 7.33333L5.83366 7.33333L5.83366 8.66667L4.50033 8.66667M3.16699 12.6667L8.50033 12.6667L8.50033 11.3333L7.16699 11.3333L7.16699 10L8.50033 10L8.50033 8.66667L7.16699 8.66667L7.16699 7.33333L8.50033 7.33333L8.50033 6L3.16699 6M9.83366 4.66667L11.167 4.66667L11.167 3.33333L9.83366 3.33333M9.83366 7.33333L11.167 7.33333L11.167 6L9.83366 6M9.83366 10L11.167 10L11.167 8.66667L9.83366 8.66667M9.83366 12.6667L11.167 12.6667L11.167 11.3333L9.83366 11.3333M12.5003 4.66667L13.8337 4.66667L13.8337 3.33333L12.5003 3.33333M12.5003 7.33333L13.8337 7.33333L13.8337 6L12.5003 6M12.5003 10L13.8337 10L13.8337 8.66667L12.5003 8.66667M12.5003 12.6667L13.8337 12.6667L13.8337 11.3333L12.5003 11.3333M8.50033 4.66667L8.50033 2L15.167 2L15.167 14L1.83366 14L1.83366 4.66667L8.50033 4.66667Z",
    fill: "#8D1912"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.50e23f5a553b470d7cd78b4b59efd4e2.svg";
export { ForwardRef as ReactComponent };